<template>
  <div id="app">
    <header class="site-header">
      <router-link to="/" class="logo-link">
        <img alt="JeepWarehouse Logo" src="./assets/jw_logo.jpg" class="site-logo">
      </router-link>
      <nav class="main-menu">
        <router-link to="/ducking">Showcase</router-link>
        <router-link to="/spotlight">Product Spotlight</router-link>
        <router-link to="/tv">Jeep TV</router-link>
        <router-link to="/events">Jeep Events</router-link>
        <router-link to="/clubs">Clubs</router-link>
        <router-link to="/about">About Us</router-link>
      </nav>
    </header>
    <router-view />
  </div>
</template>


<script>
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';

export default {
  name: 'App',
  setup() {
    const router = useRouter();
    onMounted(() => {
      console.log('Debug: App.vue mounted');
      router.afterEach((to) => {
        console.log('Debug: Navigated to', to.fullPath);
      });
    });
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.debug-message {
  color: #bfa16c;
  font-size: 1rem;
  margin-bottom: 1rem;
  text-align: center;
}
</style>

<style>
#app {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
  background: #f4f1ed;
  color: #2c2c2c;
  min-height: 100vh;
  margin: 0;
  font-weight: 400;
  line-height: 1.6;
}
.site-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(90deg, #bfa16c 0%, #3a2c1a 100%);
  padding: 1.5rem 0 1rem 0;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}
.logo-link {
  text-decoration: none;
  transition: transform 0.2s ease-in-out;
}
.logo-link:hover {
  transform: scale(1.05);
}
.site-logo {
  width: 180px;
  height: auto;
  margin-bottom: 0.5rem;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(63, 42, 26, 0.15);
  cursor: pointer;
}
.site-title {
  font-size: 2.2rem;
  font-weight: bold;
  color: #3a2c1a;
  margin-bottom: 1rem;
  letter-spacing: 2px;
  text-shadow: 1px 1px 0 #bfa16c;
}
.main-menu {
  display: flex;
  gap: 2rem;
  margin-bottom: 1rem;
}
.main-menu .router-link-active {
  color: #bfa16c;
  font-weight: bold;
  border-bottom: 2px solid #bfa16c;
}
.main-menu a {
  color: #fff;
  text-decoration: none;
  font-size: 1.1rem;
  padding: 0.5rem 0.8rem;
  border-radius: 6px;
  transition: background 0.2s, color 0.2s;
}
.main-menu a:hover {
  background: #bfa16c;
  color: #3a2c1a;
}
</style>
